/*
 * @Author: git config zhang && 10899060+inheaven98@user.noreply.gitee.com
 * @Date: 2024-02-21 15:10:16
 * @LastEditors: inHeaven98 10899060+inheaven98@user.noreply.gitee.com
 * @LastEditTime: 2024-03-07 11:34:33
 * @FilePath: \cei-saas-platform\src\utils\resetMessage.js
 * @Description:自定义message
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */

import { Message } from 'element-ui'
let messageInstance = null
const resetMessage = (options) => {
	if (messageInstance) {
		messageInstance.close()
	}
	messageInstance = Message(options)
}
;['error', 'success', 'info', 'warning'].forEach((type) => {
	resetMessage[type] = (options) => {
		if (typeof options === 'string') {
			options = {
				message: options
			}
		}
		options.type = type
		return resetMessage(options)
	}
})
export const message = resetMessage

